class TzsvHeaderSearchForm extends SearchForm {
	constructor () {
		super();
		this.list = this.querySelector('.tzsv-suggested-search-list');
		this.items = this.list ? Array.from(this.list.querySelectorAll('.tzsv-suggested-search-list__item')) : [];

		if (this.input) {
			this.input.addEventListener('focusout', this.onFocusOut.bind(this));
			this.input.addEventListener('focus', this.updateList.bind(this));
		}
	}

	onFocusOut () {
		if (!this.list) return;
		setTimeout(() => {
			if (!this.contains(document.activeElement)) this.list.hidden = true;
		});
	}

	onFormReset (event) {
		super.onFormReset(event);
		if (this.list) this.list.hidden = true;
	}

	onChange (event) {
		super.onChange(event);
		this.updateList();
	}

	updateList () {
		if (!this.list) return;

		const query = this.input.value.trim().toLowerCase();

		if (query.length < 3) {
			this.list.hidden = true;
			return;
		}

		let hasVisibleItem = false;
		this.items.forEach((item) => {
			const isMatch = item.dataset.name.includes(query);
			item.classList.toggle('hidden', !isMatch);
			if (isMatch) hasVisibleItem = true;
		});

		this.list.hidden = !hasVisibleItem;
	}
}

if (!customElements.get('tzsv-search-form')) {
	customElements.define('tzsv-search-form', TzsvHeaderSearchForm);
}
